/*
 * L.Control.GeoSearch - search for an address and zoom to its location
 * https://github.com/smeijer/leaflet.control.geosearch
 */

L.GeoSearch = {};
L.GeoSearch.Provider = {};

L.GeoSearch.Result = function (x, y, label) {
    this.X = x;
    this.Y = y;
    this.Label = label;
};

L.Control.GeoSearch = L.Control.extend({
    options: {
        position: 'topleft'
    },

    _config: {
        country: '',
        searchLabel: 'search for address ...',
        notFoundMessage: 'Sorry, that address could not be found.',
        messageHideDelay: 3000,
        zoomLevel: 18
    },

    initialize: function (options) {
        L.Util.extend(this.options, options);
        L.Util.extend(this._config, options);
    },

    onAdd: function (map) {
        this._map = map;
        this._container = L.DomUtil.create('div', 'leaflet-control-geosearch');

        var toolbar = L.DomUtil.create('div', 'leaflet-control-geosearch-toolbar');
        var button = L.DomUtil.create('a', 'fa fa-search');
        button.href = "#";

        toolbar.appendChild(button);
        this._container.appendChild(toolbar);

        L.DomEvent
            .addListener(this._container, 'click', L.DomEvent.stop)
            .on(button, 'click', L.DomEvent.stopPropagation)
			.on(button, 'mousedown', L.DomEvent.stopPropagation)
			.on(button, 'dblclick', L.DomEvent.stopPropagation)
			.on(button, 'click', L.DomEvent.preventDefault)
			.on(button, 'click', this._toggleSearchBar, this);

        L.DomEvent.disableClickPropagation(this._container);

        return this._container;
    },
    
    _toggleSearchBar: function () {
        if (this.open) {
            this._destroySearchBar();
        } else {
            this._showSearchBar();
        }
    },
    
    _destroySearchBar: function () {
        this._container.removeChild(this._container.childNodes[1]);
        this.open = false;
    }, 
    
    _showSearchBar: function () {
        var searchContainer = L.DomUtil.create('div', 'leaflet-control-geosearch-qry-container', this._container),
            inputGroup = L.DomUtil.create('div', 'input-group input-group-sm', searchContainer),
            searchbox = L.DomUtil.create('input', 'form-control', inputGroup),
            btnWrap = L.DomUtil.create('span', 'input-group-btn', inputGroup),
            btn = L.DomUtil.create('button', 'btn btn-primary', btnWrap),
            msgbox = L.DomUtil.create('div', 'leaflet-control-geosearch-msg', searchContainer),
            resultslist = L.DomUtil.create('ul', '', msgbox);
        
        searchbox.id = 'leaflet-control-geosearch-qry';
        searchbox.type = 'text';
        searchbox.placeholder = this._config.searchLabel;
        btn.innerText = "Go";
        msgbox.id = 'leaflet-control-geosearch-msg';
        resultslist.id = 'leaflet-control-geosearch-results';

        this._searchContainer = searchContainer;
        this._searchbox = searchbox;
        this._searchbtn = btn;
        this._msgbox = msgbox;
        this._resultslist = resultslist;
        
        L.DomEvent
            .addListener(this._container, 'click', L.DomEvent.stop)
            .addListener(this._searchbox, 'keypress', this._onKeyUp, this)
            .addListener(this._searchbtn, 'click', this._onSearchButtonClick, this);

        this.open = true;
        searchbox.focus();
    }, 

    geosearch: function (qry) {
        try {
            var provider = this._config.provider;

            if(typeof provider.GetLocations == 'function') {
                var results = provider.GetLocations(qry, function(results) {
                    this._processResults(results);
                }.bind(this));
            }
            else {
                var url = provider.GetServiceUrl(qry);
                this.sendRequest(provider, url);
            }
        }
        catch (error) {
            this._printError(error);
        }
    },

    sendRequest: function (provider, url) {
        var that = this;

        window.parseLocation = function (response) {
            var results = provider.ParseJSON(response);
            that._processResults(results);

            document.body.removeChild(document.getElementById('getJsonP'));
            delete window.parseLocation;
        };

        function getJsonP (url) {
            url = url + '&callback=parseLocation';
            var script = document.createElement('script');
            script.id = 'getJsonP';
            script.src = url;
            script.async = true;
            document.body.appendChild(script);
        }

        if (XMLHttpRequest) {
            var xhr = new XMLHttpRequest();

                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4) {
                        if (xhr.status == 200) {
                            var response = JSON.parse(xhr.responseText),
                                results = provider.ParseJSON(response);

                            that._processResults(results);
                        } else if (xhr.status == 0 || xhr.status == 400) {
                            getJsonP(url);
                        } else {
                            that._printError(xhr.responseText);
                        }
                    }
                };

                xhr.open('GET', url, true);
                xhr.send();           
        }
    },

    _processResults: function(results) {
        if (results.length > 0) {
            this._map.fireEvent('geosearch_foundlocations', { Locations: results });
        }

        if (results.length === 1) {
            this._showLocation(results[0]);
        }
        else if (results.length > 1) {
            this._handleDisambiguation(results);
        } else {
            this._printError(this._config.notFoundMessage);
        }
    },

    _showLocation: function (location) {
        this._map.setView([location.Y, location.X], this._config.zoomLevel, false);
        this._map.fireEvent('geosearch_showlocation', {Location: location});
    },
    
    _handleDisambiguation: function (locations) {
        var self = this;
        var elem = this._resultslist;
        elem.innerHTML = '';

        for (var i = 0; i < locations.length; i++) {
            var suggestion = L.DomUtil.create('li', 'geosearch-disambiguation-' + i);
            var suggestionLink = L.DomUtil.create('a');
            suggestionLink.href = '#';
            suggestionLink.innerText = locations[i].Label;
            L.DomEvent.addListener(suggestion, 'click', function (e) {
                self._destroySearchBar();
                e.preventDefault();
                var idx = this.className.split('geosearch-disambiguation-')[1];
                self._showLocation(locations[idx]);
                elem.style.display = 'none';
                return false;
            });

            suggestion.appendChild(suggestionLink);

            elem.appendChild(suggestion);
        }
        
        elem.style.display = 'block';
    }, 

    _printError: function(message) {
        var elem = this._resultslist;
        elem.innerHTML = '<li>' + message + '</li>';
        elem.style.display = 'block';

        setTimeout(function () {
            elem.style.display = 'none';
        }, 3000);
    },
    
    _onSearchButtonClick: function() {
        var queryBox = document.getElementById('leaflet-control-geosearch-qry');
        
        this.geosearch(queryBox.value);
        queryBox.focus();
    },

    _onKeyUp: function (e) {
        var esc = 27,
            enter = 13,
            queryBox = document.getElementById('leaflet-control-geosearch-qry');

        if (e.keyCode === esc) { // escape key detection is unreliable
            queryBox.value = '';
            this._map._container.focus();
        } else if (e.keyCode === enter) {
            this.geosearch(queryBox.value);
        }
    }
});

L.Map.mergeOptions({
    geoControl: false
});

L.Map.addInitHook(function () {
    if (this.options.geoControl) {
        this.geoControl = new L.Control.GeoSearch();
        this.addControl(this.geoControl);
    }
});
define("leaflet-geosearch", function(){});

